import React from 'react'
import Card from './Card'

import { useTranslation } from "react-i18next";


import aging from "../../images/event/Genome_Expo_2022_old_man_icon.png"
import scientist from "../../images/event/Genome_Expo_2022_scientist_icon.png"
import knitting from "../../images/event/Genome_Expo_2022_sewing_machine_icon.png"
import fish from "../../images/event/Genome_Expo_2022_fish_icon.png"
import lecture from "../../images/event/Genome_Expo_2022_lecture_icon.png"
import music from "../../images/event/Genome_Expo_2022_music_icon.png"

import './Card.css'

const Cards = () => {
  const { t } = useTranslation();

  return (
    <>
    <div className='card-wrapper'>
        <Card img={aging} title={t("event_program_title1")} date={t("event_program_date1")}
          description_1={t("event_program_desc1_1")}
          description_2={t("event_program_desc1_2")}
          description_3={t("event_program_desc1_3")}
          description_4=""
          />
        <Card img={scientist} title={t("event_program_title2")} date={t("event_program_date2")}
          description_1={t("event_program_desc2_1")}
          description_2={t("event_program_desc2_2")}
          description_3={t("event_program_desc2_3")}
          description_4=""
          />
        <Card img={knitting} title={t("event_program_title3")} date={t("event_program_date3")}
          description_1={t("event_program_desc3_1")}
          description_2={t("event_program_desc3_2")}
          description_3={t("event_program_desc3_3")}
          description_4=""
          />
        <Card img={fish} title={t("event_program_title4")} date={t("event_program_date4")}
          description_1={t("event_program_desc4_1")}
          description_2={t("event_program_desc4_2")}
          description_3=""
          description_4=""
          />
        {/* <Card img={lecture} title="시민 강좌" date="(전일. 15:00-16:20)"
          description_1="• 열공모드! 더 배우고 싶어요!"
          description_2="• 유명 국내 석학들 초청 시민 강좌"
          description_3="• 박종화, 박상철, 정해영 교수 등"
          description_4=""
          /> */}
        <Card img={music} title={t("event_program_title5")} date={t("event_program_date5")}
          description_1={t("event_program_desc5_1")}
          description_2={t("event_program_desc5_2")}
          description_3=""
          description_4=""
          />
    </div>
    </>
  )
}

export default Cards